/* eslint-disable indent */
<template>
  <div class="item-rigts">
    <div class="canvas-bg" id="bgcanvas">
      <div class="loading" v-show="loading">加载中...</div>
      <canvas id="chess" ref="myCanvas">不支持Canvas</canvas>
      <!-- <div id="box-bg">
        <img ref="conf" style="width:30px;height:30px; z-index:100; display:none" v-for='(item) in Chess' :key='item.id' :src='item.url' :id="item.ids"/>
      </div> -->
      <!-- <div>
        <img ref="confs" style="width:30px;height:30px; z-index:12200; display:none" v-for='(item) in aginChess' :key='item.id' :src='item.url' :id="item.ids"/>
      </div> -->
    </div>
    <!-- <div class="center">
      <el-button type="primary"  round @click="refreshs">刷新</el-button>
    </div> -->
  </div>
</template>

<script>
import gambit from '../assets/js/gambit'
import {updateEnrollFractionById} from '../api/index'
let chessGoNum = 0
let com = {}
com.gambit = gambit
let play = {}
com.class = {}
com.bylaw = {}
com.chessGoNumber = 0
// console.log('this.initCanvas()', this.initCanvas())
export default {
  name: 'cetGoChess',
  props: {
    goChess: Array,
    reFresh: Boolean
  },
  data () {
    return {
      content: [],
      enrollItemBanks: [],
      Chess: [],
      answerChess: [],
      blackChess: [],
      total: 0,
      testIndex: 0, // 题目索引
      clickNumber: 0,
      canGoChess: true,
      banMa: true,
      banXiang: true,
      existe: true,
      faceState: false,
      rX: 0,
      rY: 0,
      hX: 0,
      hY: 0,
      chessGoNumber: 0,
      quesionNumber: 0,
      eatChess: false,
      isError: [],
      redanswerlength: 0,
      success: 0,
      isTrue: true,
      selectnum: 0,
      gradId: '',
      levelexam: '',
      loading: true
    }
  },
  created () {
    
    this.$set(this.goChess, this.reFresh)
    // console.log('this.goChess', this.goChess.length, this.goChess)
    let stuInfo = JSON.parse(localStorage.getItem('studentInfo'))
    console.log('stuInfo', stuInfo)
    this.name = stuInfo.name
    this.levelexam = stuInfo.levelexam
    this.testId = stuInfo.testId
    this.exchangCode = stuInfo.exchangCode
    this.gradId = stuInfo.gradId
    // console.log('canshu', this.name, this.levelexam, this.testId, this.exchangCode, this.gradId)
    // console.log('this.$route.query', this.$route)
    if (this.levelexam === '十三级' ||this.levelexam === '十二级' ||this.levelexam === '十一级' || this.levelexam === '十级' || this.levelexam === '九级'||this.levelexam === '八级' ) {
      this.enrollItemBanks = this.goChess[0]
      this.selectnum = this.goChess[1]
      // console.log(this.enrollItemBanks)
      this.total = this.goChess[0].length
    } else {
      this.enrollItemBanks = this.goChess
      this.total = this.goChess.length
    }
    com.initMaplist = this.enrollItemBanks
    com.initMap = com.initMaplist[chessGoNum].ss
    var that = this

    com.init = function (stype) {
      var stypes = com.stype // 样式1
      com.width = stypes.width// 画布宽度
      com.height = stypes.height// 画布高度
      com.spaceX = stypes.spaceX// 着点X跨度
      com.spaceY = stypes.spaceY// 着点Y跨度
      com.pointStartX = stypes.pointStartX// 第一个着点X坐标;
      com.pointStartY = stypes.pointStartY// 第一个着点Y坐标;
      com.page = stypes.page// 图片目录

      // com.get("box").style.width = com.width+130+"px";  // id为box的div宽度加130
      // com.get('box').style.width = 100 + '%' // id为box的div宽度加130
      com.canvas = document.getElementById('chess') // 画布
      // console.log('com.canvas', com.canvas, com.canvas.getContext('2d'))
      com.ct = com.canvas.getContext('2d')
      com.canvas.width = com.width
      com.canvas.height = com.height

      com.childList = com.childList || [] // 创建数组childList，保存数据
      // z(com.initMap.join())
      com.loadImages(com.page)// 载入图片/图片目录
      setTimeout(() => {
        com.onload()
      }, 2500)
    }
    com.onload = function () {
      // console.log('com', com.initMap)
      com.bg = new com.class.Bg()
      com.dot = new com.class.Dot()
      com.pane = new com.class.Pane()
      com.pane.isShow = false
      com.childList = [com.bg, com.dot, com.pane]
      com.mans = {}// 棋子集合
      // console.log('com.initMap', com.initMap)
      com.createMans(com.initMap)
      com.bg.show()
      play.isPlay = true
      play.depth = 4
      play.init()
      that.loading = false
      document.addEventListener('touchmove', function (e) {
        e.preventDefault()
      })
    }
    com.show = function () {
      com.ct.clearRect(0, 0, com.width, com.height)
      for (var e = 0; e < com.childList.length; e++) {
        com.childList[e].show()
      }
    }
    com.stype = {
      width: 480,
      height: 530,
      spaceX: 46.5,
      spaceY: 46.5,
      pointStartX: 30,
      pointStartY: 30,
      page: 'stype_4'
    }
    // com.initMap = [
    //   ['J0', 'J0', 'J0', 'J0', 'J0', 'J0', 'J0', 'J0', 'J0'],
    //   ['c0', '', '', '', '', '', '', '', ''],
    //   ['c0', '', '', '', '', 'c0', '', '', ''],
    //   ['c0', '', '', '', '', '', '', '', ''],
    //   ['c0', '', '', '', '', '', '', '', ''],
    //   ['', '', '', '', '', '', '', '', ''],
    //   ['', '', '', '', '', '', '', '', ''],
    //   ['', '', '', '', '', '', '', '', ''],
    //   ['', '', '', '', 's0', '', '', 'C0', ''],
    //   ['', '', '', 's1', '', 'j0', '', '', '']
    // ]
    // 显示移动的棋子外框
    com.showPane = function (x, y, newX, newY) {
      com.pane.isShow = true
      com.pane.x = x
      com.pane.y = y
      com.pane.newX = newX
      com.pane.newY = newY
    }
    com.get = function (id) {
      return document.getElementById(id)
    }
    com.loadImages = function (stype) {
      // // 绘制棋盘
      com.bgImg = new Image()
      com.bgImg.src = 'https://app.tongxinyizhi.com/stype_4/bg.png'

      // 提示点
      com.dotImg = new Image()
      com.dotImg.src = 'https://app.tongxinyizhi.com/stype_4/dot.png'

      // 棋子
      for (var i in com.args) {
        com[i] = {}
        com[i].img = new Image()
        com[i].img.src = 'https://app.tongxinyizhi.com/stype_4/' + com.args[i].img + '.png'
      }

      // 棋子外框
      com.paneImg = new Image()
      com.paneImg.src = 'https://app.tongxinyizhi.com/stype_4/r_box.png'

      // document.getElementsByTagName('body')[0].style.background = 'url(img/' + stype + '/background.png)'
    }
    com.createMans = function (map) {
       console.log('map', map)
      for (var i = 0; i < map.length; i++) {
        for (var n = 0; n < map[i].length; n++) {
          var key = map[i][n]
          if (key) {
            com.mans[key] = new com.class.Man(key)
            com.mans[key].x = n
            com.mans[key].y = i
            com.childList.push(com.mans[key])
          }
        }
      }
    }
    com.alert = function (e, t, n) {
      if (typeof e !== 'object') {
        try {
          console.log(e)
        } catch (r) {}
      }
      var i = []
      for (var s in e) i.push(s + ' = ' + e[s])
      try {
        console.log(i.join(n || '\n'))
      } catch (r) {}
    }
    com.getDomXY = function (e) {
      var t = e.offsetLeft
      var n = e.offsetTop
      var r = e.offsetParent
      while (r !== null) {
        t += r.offsetLeft
        n += r.offsetTop
        r = r.offsetParent
      }
      return {
        x: t,
        y: n
      }
    }
    com.getCookie = function (e) {
      if (document.cookie.length > 0) {
        let start = document.cookie.indexOf(e + '=')
        if (start !== -1) {
          start = start + e.length + 1
          let end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          return unescape(document.cookie.substring(start, end))
        }
      }
      return false
    }
    // 二维数组克隆
    com.arr2Clone = function (arr) {
      var newArr = []
      for (var i = 0; i < arr.length; i++) {
        newArr[i] = arr[i].slice()
      }
      return newArr
    }
    com.getData = function (e, t) {
      var n = false
      let ActiveXObject
      if (window.XMLHttpRequest) {
        n = new XMLHttpRequest()
      } else if (window.ActiveXObject) {
        n = new ActiveXObject('Microsoft.XMLHTTP')
      }
      if (n) {
        n.open('GET', e)
        n.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        n.onreadystatechange = function () {
          if (n.readyState === 4 && n.status === 200) {
            t(n.responseText)
          }
        }
        n.send(null)
      }
    }
    // 把坐标生成着法
    com.createMove = function (map, x, y, newX, newY) {
      var h = ''
      var man = com.mans[map[y][x]]
      h += man.text
      map[newY][newX] = map[y][x]
      delete map[y][x]
      if (man.my === 1) {
        var mumTor = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
        newX = 8 - newX
        h += mumTor[8 - x]
        if (newY > y) {
          h += '退'
          if (man.pater === 'm' || man.pater === 's' || man.pater === 'x') {
            h += mumTor[newX]
          } else {
            h += mumTor[newY - y - 1]
          }
        } else if (newY < y) {
          h += '进'
          if (man.pater === 'm' || man.pater === 's' || man.pater === 'x') {
            h += mumTor[newX]
          } else {
            h += mumTor[y - newY - 1]
          }
        } else {
          h += '平'
          h += mumTor[newX]
        }
      } else {
        var mumTob = ['１', '２', '３', '４', '５', '６', '７', '８', '９', '10']
        h += mumTob[x]
        if (newY > y) {
          h += '进'
          if (man.pater === 'M' || man.pater === 'S' || man.pater === 'X') {
            h += mumTob[newX]
          } else {
            h += mumTob[newY - y - 1]
          }
        } else if (newY < y) {
          h += '退'
          if (man.pater === 'M' || man.pater === 'S' || man.pater === 'X') {
            h += mumTob[newX]
          } else {
            h += mumTob[y - newY - 1]
          }
        } else {
          h += '平'
          h += mumTob[newX]
        }
      }
      return h
    }
    // 棋子能走的着点
    com.bylaw = {}
    // 车
    com.bylaw.c = function (x, y, map, my) {
      var cd = []
      // 左侧检索
      for (let i = x - 1; i >= 0; i--) {
        if (map[y][i]) {
          if (com.mans[map[y][i]].my !== my) cd.push([i, y])
          break
        } else {
          cd.push([i, y])
        }
      }
      // 右侧检索
      for (let i = x + 1; i <= 8; i++) {
        if (map[y][i]) {
          if (com.mans[map[y][i]].my !== my) cd.push([i, y])
          break
        } else {
          cd.push([i, y])
        }
      }
      // 上检索
      for (let i = y - 1; i >= 0; i--) {
        if (map[i][x]) {
          if (com.mans[map[i][x]].my !== my) cd.push([x, i])
          break
        } else {
          cd.push([x, i])
        }
      }
      // 下检索
      for (let i = y + 1; i <= 9; i++) {
        if (map[i][x]) {
          if (com.mans[map[i][x]].my !== my) cd.push([x, i])
          break
        } else {
          cd.push([x, i])
        }
      }
      return cd
    }

    // 马
    com.bylaw.m = function (x, y, map, my) {
      var md = []
      // 1点
      if (y - 2 >= 0 && x + 1 <= 8 && !play.map[y - 1][x] && (!com.mans[map[y - 2][x + 1]] || com.mans[map[y - 2][x + 1]].my !== my)) md.push([x + 1, y - 2])
      // 2点m
      if (y - 1 >= 0 && x + 2 <= 8 && !play.map[y][x + 1] && (!com.mans[map[y - 1][x + 2]] || com.mans[map[y - 1][x + 2]].my !== my)) md.push([x + 2, y - 1])
      // 4点
      if (y + 1 <= 9 && x + 2 <= 8 && !play.map[y][x + 1] && (!com.mans[map[y + 1][x + 2]] || com.mans[map[y + 1][x + 2]].my !== my)) md.push([x + 2, y + 1])
      // 5点
      if (y + 2 <= 9 && x + 1 <= 8 && !play.map[y + 1][x] && (!com.mans[map[y + 2][x + 1]] || com.mans[map[y + 2][x + 1]].my !== my)) md.push([x + 1, y + 2])
      // 7点
      if (y + 2 <= 9 && x - 1 >= 0 && !play.map[y + 1][x] && (!com.mans[map[y + 2][x - 1]] || com.mans[map[y + 2][x - 1]].my !== my)) md.push([x - 1, y + 2])
      // 8点
      if (y + 1 <= 9 && x - 2 >= 0 && !play.map[y][x - 1] && (!com.mans[map[y + 1][x - 2]] || com.mans[map[y + 1][x - 2]].my !== my)) md.push([x - 2, y + 1])
      // 10点
      if (y - 1 >= 0 && x - 2 >= 0 && !play.map[y][x - 1] && (!com.mans[map[y - 1][x - 2]] || com.mans[map[y - 1][x - 2]].my !== my)) md.push([x - 2, y - 1])
      // 11点
      if (y - 2 >= 0 && x - 1 >= 0 && !play.map[y - 1][x] && (!com.mans[map[y - 2][x - 1]] || com.mans[map[y - 2][x - 1]].my !== my)) md.push([x - 1, y - 2])

      return md
    }

    // 相
    com.bylaw.x = function (x, y, map, my) {
      var xd = []
      if (my === 1) { // 红方
        // 4点半
        if (y + 2 <= 9 && x + 2 <= 8 && !play.map[y + 1][x + 1] && (!com.mans[map[y + 2][x + 2]] || com.mans[map[y + 2][x + 2]].my !== my)) xd.push([x + 2, y + 2])
        // 7点半
        if (y + 2 <= 9 && x - 2 >= 0 && !play.map[y + 1][x - 1] && (!com.mans[map[y + 2][x - 2]] || com.mans[map[y + 2][x - 2]].my !== my)) xd.push([x - 2, y + 2])
        // 1点半
        if (y - 2 >= 5 && x + 2 <= 8 && !play.map[y - 1][x + 1] && (!com.mans[map[y - 2][x + 2]] || com.mans[map[y - 2][x + 2]].my !== my)) xd.push([x + 2, y - 2])
        // 10点半
        if (y - 2 >= 5 && x - 2 >= 0 && !play.map[y - 1][x - 1] && (!com.mans[map[y - 2][x - 2]] || com.mans[map[y - 2][x - 2]].my !== my)) xd.push([x - 2, y - 2])
      } else {
        // 4点半
        if (y + 2 <= 4 && x + 2 <= 8 && !play.map[y + 1][x + 1] && (!com.mans[map[y + 2][x + 2]] || com.mans[map[y + 2][x + 2]].my !== my)) xd.push([x + 2, y + 2])
        // 7点半
        if (y + 2 <= 4 && x - 2 >= 0 && !play.map[y + 1][x - 1] && (!com.mans[map[y + 2][x - 2]] || com.mans[map[y + 2][x - 2]].my !== my)) xd.push([x - 2, y + 2])
        // 1点半
        if (y - 2 >= 0 && x + 2 <= 8 && !play.map[y - 1][x + 1] && (!com.mans[map[y - 2][x + 2]] || com.mans[map[y - 2][x + 2]].my !== my)) xd.push([x + 2, y - 2])
        // 10点半
        if (y - 2 >= 0 && x - 2 >= 0 && !play.map[y - 1][x - 1] && (!com.mans[map[y - 2][x - 2]] || com.mans[map[y - 2][x - 2]].my !== my)) xd.push([x - 2, y - 2])
      }
      return xd
    }

    // 士
    com.bylaw.s = function (x, y, map, my) {
      var sd = []
      if (my === 1) { // 红方
        // 4点半
        if (y + 1 <= 9 && x + 1 <= 5 && (!com.mans[map[y + 1][x + 1]] || com.mans[map[y + 1][x + 1]].my !== my)) sd.push([x + 1, y + 1])
        // 7点半
        if (y + 1 <= 9 && x - 1 >= 3 && (!com.mans[map[y + 1][x - 1]] || com.mans[map[y + 1][x - 1]].my !== my)) sd.push([x - 1, y + 1])
        // 1点半
        if (y - 1 >= 7 && x + 1 <= 5 && (!com.mans[map[y - 1][x + 1]] || com.mans[map[y - 1][x + 1]].my !== my)) sd.push([x + 1, y - 1])
        // 10点半
        if (y - 1 >= 7 && x - 1 >= 3 && (!com.mans[map[y - 1][x - 1]] || com.mans[map[y - 1][x - 1]].my !== my)) sd.push([x - 1, y - 1])
      } else {
        // 4点半
        if (y + 1 <= 2 && x + 1 <= 5 && (!com.mans[map[y + 1][x + 1]] || com.mans[map[y + 1][x + 1]].my !== my)) sd.push([x + 1, y + 1])
        // 7点半
        if (y + 1 <= 2 && x - 1 >= 3 && (!com.mans[map[y + 1][x - 1]] || com.mans[map[y + 1][x - 1]].my !== my)) sd.push([x - 1, y + 1])
        // 1点半
        if (y - 1 >= 0 && x + 1 <= 5 && (!com.mans[map[y - 1][x + 1]] || com.mans[map[y - 1][x + 1]].my !== my)) sd.push([x + 1, y - 1])
        // 10点半
        if (y - 1 >= 0 && x - 1 >= 3 && (!com.mans[map[y - 1][x - 1]] || com.mans[map[y - 1][x - 1]].my !== my)) sd.push([x - 1, y - 1])
      }
      return sd
    }

    // 将
    com.bylaw.j = function (x, y, map, my) {
      // console.log('点击将走这里')
      var jd = []
      var isNull = (function (y1, y2) {
        // console.log('y1,y2', y1, y2)
        let jy1 = com.mans['j0'].y
        let x1 = com.mans['J0'].x
        var jy2 = com.mans['J0'].y
        for (var i = jy1 - 1; i > jy2; i--) {
          if (map[i][x1]) return false
        }
        return true
      })()

      if (my === 1) { // 红方
        // 下
        if (y + 1 <= 9 && (!com.mans[map[y + 1][x]] || com.mans[map[y + 1][x]].my !== my)) jd.push([x, y + 1])
        // 上
        if (y - 1 >= 7 && (!com.mans[map[y - 1][x]] || com.mans[map[y - 1][x]].my !== my)) jd.push([x, y - 1])
        // 老将对老将的情况
        if (com.mans['j0'].x === com.mans['J0'].x && isNull) jd.push([com.mans['J0'].x, com.mans['J0'].y])
      } else {
        // 下
        if (y + 1 <= 2 && (!com.mans[map[y + 1][x]] || com.mans[map[y + 1][x]].my !== my)) jd.push([x, y + 1])
        // 上
        if (y - 1 >= 0 && (!com.mans[map[y - 1][x]] || com.mans[map[y - 1][x]].my !== my)) jd.push([x, y - 1])
        // 老将对老将的情况
        if (com.mans['j0'].x === com.mans['J0'].x && isNull) jd.push([com.mans['j0'].x, com.mans['j0'].y])
      }
      // 右
      if (x + 1 <= 5 && (!com.mans[map[y][x + 1]] || com.mans[map[y][x + 1]].my !== my)) jd.push([x + 1, y])
      // 左
      if (x - 1 >= 3 && (!com.mans[map[y][x - 1]] || com.mans[map[y][x - 1]].my !== my))jd.push([x - 1, y])
      return jd
    }

    // 炮
    com.bylaw.p = function (x, y, map, my) {
      var pd = []
      // 左侧检索
      var ln = 0
      for (let i = x - 1; i >= 0; i--) {
        if (map[y][i]) {
          if (ln === 0) {
            ln++
            continue
          } else {
            if (com.mans[map[y][i]].my !== my) pd.push([i, y])
            break
          }
        } else {
          if (ln === 0) pd.push([i, y])
        }
      }
      // 右侧检索
      var rn = 0
      for (let i = x + 1; i <= 8; i++) {
        if (map[y][i]) {
          if (rn === 0) {
            rn++
            continue
          } else {
            if (com.mans[map[y][i]].my !== my) pd.push([i, y])
            break
          }
        } else {
          if (rn === 0) pd.push([i, y])
        }
      }
      // 上检索
      var tn = 0
      for (let i = y - 1; i >= 0; i--) {
        if (map[i][x]) {
          if (tn === 0) {
            tn++
            continue
          } else {
            if (com.mans[map[i][x]].my !== my) pd.push([x, i])
            break
          }
        } else {
          if (tn === 0) pd.push([x, i])
        }
      }
      // 下检索
      var bn = 0
      for (let i = y + 1; i <= 9; i++) {
        if (map[i][x]) {
          if (bn === 0) {
            bn++
            continue
          } else {
            if (com.mans[map[i][x]].my !== my) pd.push([x, i])
            break
          }
        } else {
          if (bn === 0) pd.push([x, i])
        }
      }
      return pd
    }

    // 卒
    com.bylaw.z = function (x, y, map, my) {
      var zd = []
      if (my === 1) { // 红方
        // 上
        if (y - 1 >= 0 && (!com.mans[map[y - 1][x]] || com.mans[map[y - 1][x]].my !== my)) zd.push([x, y - 1])
        // 右
        if (x + 1 <= 8 && y <= 4 && (!com.mans[map[y][x + 1]] || com.mans[map[y][x + 1]].my !== my)) zd.push([x + 1, y])
        // 左
        if (x - 1 >= 0 && y <= 4 && (!com.mans[map[y][x - 1]] || com.mans[map[y][x - 1]].my !== my))zd.push([x - 1, y])
      } else {
        // 下
        if (y + 1 <= 9 && (!com.mans[map[y + 1][x]] || com.mans[map[y + 1][x]].my !== my)) zd.push([x, y + 1])
        // 右
        if (x + 1 <= 8 && y >= 6 && (!com.mans[map[y][x + 1]] || com.mans[map[y][x + 1]].my !== my)) zd.push([x + 1, y])
        // 左
        if (x - 1 >= 0 && y >= 6 && (!com.mans[map[y][x - 1]] || com.mans[map[y][x - 1]].my !== my))zd.push([x - 1, y])
      }

      return zd
    }

    com.keys = {
      'c0': 'c',
      'c1': 'c',
      'm0': 'm',
      'm1': 'm',
      'x0': 'x',
      'x1': 'x',
      's0': 's',
      's1': 's',
      'j0': 'j',
      'p0': 'p',
      'p1': 'p',
      'z0': 'z',
      'z1': 'z',
      'z2': 'z',
      'z3': 'z',
      'z4': 'z',
      'z5': 'z',

      'C0': 'c',
      'C1': 'C',
      'M0': 'M',
      'M1': 'M',
      'X0': 'X',
      'X1': 'X',
      'S0': 'S',
      'S1': 'S',
      'J0': 'J',
      'P0': 'P',
      'P1': 'P',
      'Z0': 'Z',
      'Z1': 'Z',
      'Z2': 'Z',
      'Z3': 'Z',
      'Z4': 'Z',
      'Z5': 'Z'
    }
    com.value = {

      // 车价值
      c: [
        [206, 208, 207, 213, 214, 213, 207, 208, 206],
        [206, 212, 209, 216, 233, 216, 209, 212, 206],
        [206, 208, 207, 214, 216, 214, 207, 208, 206],
        [206, 213, 213, 216, 216, 216, 213, 213, 206],
        [208, 211, 211, 214, 215, 214, 211, 211, 208],

        [208, 212, 212, 214, 215, 214, 212, 212, 208],
        [204, 209, 204, 212, 214, 212, 204, 209, 204],
        [198, 208, 204, 212, 212, 212, 204, 208, 198],
        [200, 208, 206, 212, 200, 212, 206, 208, 200],
        [194, 206, 204, 212, 200, 212, 204, 206, 194]
      ],

      // 马价值
      m: [
        [90, 90, 90, 96, 90, 96, 90, 90, 90],
        [90, 96, 103, 97, 94, 97, 103, 96, 90],
        [92, 98, 99, 103, 99, 103, 99, 98, 92],
        [93, 108, 100, 107, 100, 107, 100, 108, 93],
        [90, 100, 99, 103, 104, 103, 99, 100, 90],

        [90, 98, 101, 102, 103, 102, 101, 98, 90],
        [92, 94, 98, 95, 98, 95, 98, 94, 92],
        [93, 92, 94, 95, 92, 95, 94, 92, 93],
        [85, 90, 92, 93, 78, 93, 92, 90, 85],
        [88, 85, 90, 88, 90, 88, 90, 85, 88]
      ],

      // 相价值
      x: [
        [0, 0, 20, 0, 0, 0, 20, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 23, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 20, 0, 0, 0, 20, 0, 0],

        [0, 0, 20, 0, 0, 0, 20, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [18, 0, 0, 0, 23, 0, 0, 0, 18],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 20, 0, 0, 0, 20, 0, 0]
      ],

      // 士价值
      s: [
        [0, 0, 0, 20, 0, 20, 0, 0, 0],
        [0, 0, 0, 0, 23, 0, 0, 0, 0],
        [0, 0, 0, 20, 0, 20, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],

        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 20, 0, 20, 0, 0, 0],
        [0, 0, 0, 0, 23, 0, 0, 0, 0],
        [0, 0, 0, 20, 0, 20, 0, 0, 0]
      ],

      // 奖价值
      j: [
        [0, 0, 0, 8888, 8888, 8888, 0, 0, 0],
        [0, 0, 0, 8888, 8888, 8888, 0, 0, 0],
        [0, 0, 0, 8888, 8888, 8888, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],

        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 8888, 8888, 8888, 0, 0, 0],
        [0, 0, 0, 8888, 8888, 8888, 0, 0, 0],
        [0, 0, 0, 8888, 8888, 8888, 0, 0, 0]
      ],

      // 炮价值
      p: [

        [100, 100, 96, 91, 90, 91, 96, 100, 100],
        [98, 98, 96, 92, 89, 92, 96, 98, 98],
        [97, 97, 96, 91, 92, 91, 96, 97, 97],
        [96, 99, 99, 98, 100, 98, 99, 99, 96],
        [96, 96, 96, 96, 100, 96, 96, 96, 96],

        [95, 96, 99, 96, 100, 96, 99, 96, 95],
        [96, 96, 96, 96, 96, 96, 96, 96, 96],
        [97, 96, 100, 99, 101, 99, 100, 96, 97],
        [96, 97, 98, 98, 98, 98, 98, 97, 96],
        [96, 96, 97, 99, 99, 99, 97, 96, 96]
      ],

      // 卒价值
      z: [
        [9, 9, 9, 11, 13, 11, 9, 9, 9],
        [19, 24, 34, 42, 44, 42, 34, 24, 19],
        [19, 24, 32, 37, 37, 37, 32, 24, 19],
        [19, 23, 27, 29, 30, 29, 27, 23, 19],
        [14, 18, 20, 27, 29, 27, 20, 18, 14],

        [7, 0, 13, 0, 16, 0, 13, 0, 7],
        [7, 0, 7, 0, 15, 0, 7, 0, 7],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0]
      ]
    }

    // 黑子为红字价值位置的倒置
    com.value.C = com.arr2Clone(com.value.c).reverse()
    com.value.M = com.arr2Clone(com.value.m).reverse()
    com.value.X = com.value.x
    com.value.S = com.value.s
    com.value.J = com.value.j
    com.value.P = com.arr2Clone(com.value.p).reverse()
    com.value.Z = com.arr2Clone(com.value.z).reverse()
    // 棋子们
    com.args = {
      // 红子 中文/图片地址/阵营/权重
      'c': {text: '车', img: 'r_c', my: 1, bl: 'c', value: com.value.c},
      'm': {text: '马', img: 'r_m', my: 1, bl: 'm', value: com.value.m},
      'x': {text: '相', img: 'r_x', my: 1, bl: 'x', value: com.value.x},
      's': {text: '仕', img: 'r_s', my: 1, bl: 's', value: com.value.s},
      'j': {text: '将', img: 'r_j', my: 1, bl: 'j', value: com.value.j},
      'p': {text: '炮', img: 'r_p', my: 1, bl: 'p', value: com.value.p},
      'z': {text: '兵', img: 'r_z', my: 1, bl: 'z', value: com.value.z},

      // 蓝子
      'C': {text: '車', img: 'b_c', my: -1, bl: 'c', value: com.value.C},
      'M': {text: '馬', img: 'b_m', my: -1, bl: 'm', value: com.value.M},
      'X': {text: '象', img: 'b_x', my: -1, bl: 'x', value: com.value.X},
      'S': {text: '士', img: 'b_s', my: -1, bl: 's', value: com.value.S},
      'J': {text: '帅', img: 'b_j', my: -1, bl: 'j', value: com.value.J},
      'P': {text: '炮', img: 'b_p', my: -1, bl: 'p', value: com.value.P},
      'Z': {text: '卒', img: 'b_z', my: -1, bl: 'z', value: com.value.Z}
    }
    com.class.Bg = function (img, x, y) {
      this.x = x || 0
      this.y = y || 0
      this.isShow = true
      this.show = function () {
        if (this.isShow) com.ct.drawImage(com.bgImg, com.spaceX * this.x, com.spaceY * this.y)
      }
    }
    com.class.Man = function (key, x, y) {
      this.pater = key.slice(0, 1)
      var o = com.args[this.pater]
      this.x = x || 0
      this.y = y || 0
      this.key = key
      this.my = o.my
      this.text = o.text
      this.value = o.value
      this.isShow = true
      this.alpha = 1
      this.ps = [] // 着点

      this.show = function () {
        if (this.isShow) {
          com.ct.save()
          com.ct.globalAlpha = this.alpha
          com.ct.drawImage(com[this.pater].img, com.spaceX * this.x + com.pointStartX, com.spaceY * this.y + com.pointStartY)
          com.ct.restore()
        }
      }

      this.bl = function (map) {
        var maps = map || play.map
        return com.bylaw[o.bl](this.x, this.y, maps, this.my)
      }
    }
    com.class.Pane = function (img, x, y) {
      this.x = x || 0
      this.y = y || 0
      this.newX = x || 0
      this.newY = y || 0
      this.isShow = true

      this.show = function () {
        if (this.isShow) {
          com.ct.drawImage(com.paneImg, com.spaceX * this.x + com.pointStartX, com.spaceY * this.y + com.pointStartY)
          com.ct.drawImage(com.paneImg, com.spaceX * this.newX + com.pointStartX, com.spaceY * this.newY + com.pointStartY)
        }
      }
    }
    com.class.Dot = function (img, x, y) {
      this.x = x || 0
      this.y = y || 0
      this.isShow = true
      this.dots = []

      this.show = function () {
        for (var i = 0; i < this.dots.length; i++) {
          if (this.isShow) com.ct.drawImage(com.dotImg, com.spaceX * this.dots[i][0] + 18 + com.pointStartX, com.spaceY * this.dots[i][1] + 17 + com.pointStartY)
        }
      }
    }
    play.init = function () {
      play.my = 1
      play.map = com.arr2Clone(com.initMap)
      play.nowManKey = false
      play.pace = []
      play.isPlay = true
      play.mans = com.mans
      play.bylaw = com.bylaw
      play.show = com.show
      play.showPane = com.showPane
      play.isOffensive = true
      play.depth = play.depth || 3
      play.isFoul = false
      com.pane.isShow = false
      for (var e = 0; e < play.map.length; e++) {
        for (var t = 0; t < play.map[e].length; t++) {
          var n = play.map[e][t]
          if (n) {
            com.mans[n].x = t
            com.mans[n].y = e
            com.mans[n].isShow = true
          }
        }
      }
      play.show()
      com.canvas.onclick = function (e) {
        // console.log(e)
        play.clickCanvas(e)
      }
      // com.canvas.addEventListener('click', play.clickCanvas)
      // com.get('regretBn').addEventListener('click', function (e) {
      //   play.regret()
      // })
    }
    // 点击棋盘事件
    play.clickCanvas = function (e) {
      console.log('点击棋盘', e)
      // console.log(e, play.isPlay)
      if (!play.isPlay) {
        return false
      } else {
        var key = play.getClickMan(e)
        // console.log('key', key)
        var point = play.getClickPoint(e)
        // console.log('point', point)
        var x = point.x
        var y = point.y

        if (key) {
          play.clickMan(key, x, y)
        } else {
          play.clickPoint(x, y)
        }
        play.isFoul = play.checkFoul()// 检测是不是长将
        // console.log('play.isFoul', play.isFoul)
      }
    }

    // 点击棋子，两种情况，选中或者吃子
    play.clickMan = function (key, x, y) {
      var man = com.mans[key]
      // 吃子
      if (play.nowManKey && play.nowManKey !== key && man.my !== com.mans[ play.nowManKey ].my) {
        console.log('这是走哪里1')
        // man为被吃掉的棋子
        if (play.indexOfPs(com.mans[play.nowManKey].ps, [x, y])) {
          // console.log('key是将', key)
          man.isShow = false
          var pace = com.mans[play.nowManKey].x + '' + com.mans[play.nowManKey].y
          // z(bill.createMove(play.map,man.x,man.y,x,y))
          delete play.map[com.mans[play.nowManKey].y][com.mans[play.nowManKey].x]
          play.map[y][x] = play.nowManKey
          com.showPane(com.mans[play.nowManKey].x, com.mans[play.nowManKey].y, x, y)
          com.mans[play.nowManKey].x = x
          com.mans[play.nowManKey].y = y
          com.mans[play.nowManKey].alpha = 1

          play.pace.push(pace + x + y)
          play.nowManKey = false
          com.pane.isShow = false
          com.dot.dots = []
          com.show()
          // com.get('clickAudio').play()
          // eslint-disable-next-line no-implied-eval
          setTimeout(() => {
            play.AIPlay()
          }, 500)
          if (key === 'j0') play.showWin(-1)
          if (key === 'J0') play.showWin(1)
        }
      } else {
        console.log('这是走哪里2')
        // 选中棋子
        if (man.my === 1) {
          if (com.mans[play.nowManKey]) com.mans[play.nowManKey].alpha = 1
          man.alpha = 0.6
          com.pane.isShow = false
          play.nowManKey = key
          com.mans[key].ps = com.mans[key].bl() // 获得所有能着点
          com.dot.dots = com.mans[key].ps
          com.show()
          // com.get("selectAudio").start(0);
          // com.get('selectAudio').play()
        }
      }
    }

    // 点击着点
    play.clickPoint = function (x, y) {
      console.log('这是走哪里3', x, y)
      var key = play.nowManKey
      var man = com.mans[key]
      if (play.nowManKey) {
        if (play.indexOfPs(com.mans[key].ps, [x, y])) {
          var pace = man.x + '' + man.y
          // z(bill.createMove(play.map,man.x,man.y,x,y))
          delete play.map[man.y][man.x]
          play.map[y][x] = key
          com.showPane(man.x, man.y, x, y)
          man.x = x
          man.y = y
          man.alpha = 1
          play.pace.push(pace + x + y)
          play.nowManKey = false
          com.dot.dots = []
          com.show()
          // com.get('clickAudio').play()
          // setTimeout('play.AIPlay()', 500)
          setTimeout(() => {
            play.AIPlay()
          }, 500)
        } else {
          // alert("不能这么走哦！")
        }
      }
    }

    // Ai自动走棋
    play.AIPlay = function () {
      console.log('AI')
      com.chessGoNumber++
      // return
      play.my = -1
      var pace = AI.init(play.pace.join(''))
      console.log(pace, 'pace', play.pace)
      if (!pace) {
        play.showWin(1)
        return
      }
      play.pace.push(pace.join(''))
      var key = play.map[pace[1]][pace[0]]
      // console.log('key', key, 'map', play.map)
      play.nowManKey = key

      var keys = play.map[pace[3]][pace[2]]
      // console.log('keys', keys)
      if (keys) {
        play.AIclickMan(keys, pace[2], pace[3])
      } else {
        play.AIclickPoint(pace[2], pace[3])
      }
      // com.get('clickAudio').play()
    }

    // 检查是否长将
    play.checkFoul = function () {
      // console.log('com', com, 'play', play)
      var p = play.pace
      var len = parseInt(p.length, 10)
      // console.log('长将', len, p[len - 1])
      if (len > 11 && p[len - 1] === p[len - 5] && p[len - 5] === p[len - 9]) {
        return p[len - 4].split('')
      }
      return false
    }

    play.AIclickMan = function (key, x, y) {
      console.log('这是走哪里4', key, x, y)
      var man = com.mans[key]
      // 吃子
      man.isShow = false
      delete play.map[com.mans[play.nowManKey].y][com.mans[play.nowManKey].x]
      play.map[y][x] = play.nowManKey
      play.showPane(com.mans[play.nowManKey].x, com.mans[play.nowManKey].y, x, y)

      com.mans[play.nowManKey].x = x
      com.mans[play.nowManKey].y = y
      play.nowManKey = false

      com.show()
      if (key === 'j0') play.showWin(-1)
      if (key === 'J0') play.showWin(1)
    }

    play.AIclickPoint = function (x, y) {
      console.log('这是走哪里5', x, y)
      var key = play.nowManKey
      var man = com.mans[key]
      if (play.nowManKey) {
        delete play.map[com.mans[play.nowManKey].y][com.mans[play.nowManKey].x]
        play.map[y][x] = key

        com.showPane(man.x, man.y, x, y)

        man.x = x
        man.y = y
        play.nowManKey = false
      }
      com.show()
      console.log(com.chessGoNumber)
      // if (com.chessGoNumber === 10) {
      //   console.log(com.chessGoNumber, 'hajdls')
      //   play.showWin(-1)
      // }
      if (stuInfo.levelexam === '十级') {
        if (com.chessGoNumber === 15) { 
          play.showWin(-1)
        }
      } else if (stuInfo.levelexam === '十一级' || stuInfo.levelexam === '九级') {
        if (com.chessGoNumber === 3) {
          play.showWin(-1)
        }
      }else if(stuInfo.levelexam === '八级'){
        if (com.chessGoNumber === 25) {
          play.showWin(-1)
        }
      }else if(stuInfo.levelexam === '十二级' || stuInfo.levelexam === '十三级'){
        if (com.chessGoNumber >= 2) {
          play.showWin(-1)
        }
      }

    }

    play.indexOfPs = function (ps, xy) {
      for (var i = 0; i < ps.length; i++) {
        if (ps[i][0] === xy[0] && ps[i][1] === xy[1]) return true
      }
      return false
    }

    // 获得点击的着点
    play.getClickPoint = function (e) {
      var domXY = com.getDomXY(com.canvas)
      var x = Math.round((e.pageX - domXY.x - com.pointStartX - 20) / com.spaceX)
      var y = Math.round((e.pageY - domXY.y - com.pointStartY - 20) / com.spaceY)
      return {'x': x, 'y': y}
    }

    // 获得棋子
    play.getClickMan = function (e) {
      // console.log('1')
      var clickXY = play.getClickPoint(e)
      var x = clickXY.x
      var y = clickXY.y
      if (x < 0 || x > 8 || y < 0 || y > 9) return false
      return (play.map[y][x] && play.map[y][x] !== '0') ? play.map[y][x] : false
    }

    // 结果弹出框
    // function showToast (msg, duration) {
    //   duration = isNaN(duration) ? 3000 : duration
    //   var m = document.createElement('div')
    //   m.innerHTML = msg
    //   m.style.cssText = 'width:50%; min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 50px; color:#fff; line-height:50px; text-align:center; font-size:20px; border-radius: 20px; position:fixed; top: 50%; left: 50%;transform: translate(-50%, -50%); z-index:999999;'
    //   document.body.appendChild(m)
    //   setTimeout(function () {
    //     var d = 0.5
    //     m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in'
    //     m.style.opacity = '0'
    //     setTimeout(function () { document.body.removeChild(m) }, d * 1000)
    //   }, duration)
    // }

    play.showWin = function (my) {
      play.isPlay = false
      console.log('that.total', that.total, 'chessGoNum', chessGoNum)
      if (my === 1) {
        console.log('成功完成')
        if (that.total - 1 === chessGoNum) {
          that.success++
          that.$message({
            message: '已完成答题',
            center: true,
            type: 'success'
          })
          // alert('答完题')
          setTimeout(() => {
            if (that.levelexam === '十三级') {
              that.success = that.selectnum + that.success
              that.updateEnrollFractionById(that.success, that.levelexam, that.gradId)
            } else {
              that.success = that.selectnum + that.success
              that.updateEnrollFractionById(that.success, that.levelexam, that.gradId)
            }
          }, 2000)
        } else {
          that.$message({
            message: '进入下一题',
            center: true,
            type: 'success'
          })
          // alert('成功')
          setTimeout(() => {
            chessGoNum++
            that.success++
            that.testIndex++
            com.chessGoNumber = 0
            that.$emit('gochessnum', that.success)
            that.$emit('gochestest', that.testIndex)
            com.initMap = com.initMaplist[chessGoNum].ss
            com.onload()
          }, 2000)
        }
      } else {
        console.log('失败完成')
        if (that.total - 1 === chessGoNum) {
          that.$message({
            message: '已完成答题',
            center: true,
            type: 'success'
          })
          // alert('答完题')
          setTimeout(() => {
           
              that.success = that.selectnum + that.success
              that.updateEnrollFractionById(that.success, that.levelexam, that.gradId)
            //    if (that.levelexam === '十三级') {
            //   that.success = that.selectnum + that.success
            //   that.updateEnrollFractionById(that.success, that.levelexam, that.gradId)
            // } else {
            // }
          }, 2000)
        } else {
          that.$message({
            message: '进入下一题',
            center: true,
            type: 'warning'
          })
          // alert('失败')
          // console.log(that)
          setTimeout(() => {
            chessGoNum++
            that.testIndex++
            com.chessGoNumber = 0
            that.$emit('gochessnum', that.success)
            that.$emit('gochestest', that.testIndex)
            com.initMap = com.initMaplist[chessGoNum].ss
            com.onload()
          }, 2000)
        }
      }
      // console.log('window.showWin', window.showWin)
      // showWin(my)
    }
    var AI = {}
    AI.historyTable = {}// 历史表

    // 人工智能初始化
    AI.init = function (pace) {
      // console.log(pace)
      var bill = AI.historyBill || com.gambit // 开局库
      if (bill.length) {
        var len = pace.length
        var arr = []
        // 先搜索棋谱
        for (var i = 0; i < bill.length; i++) {
          if (bill[i].slice(0, len) === pace) {
            arr.push(bill[i])
          }
        }
        if (arr.length) {
          var inx = Math.floor(Math.random() * arr.length)
          AI.historyBill = arr
          return arr[inx].slice(len, len + 4).split('')
        } else {
          AI.historyBill = []
        }
      }
      // 如果棋谱里面没有，人工智能开始运作
      // var initTime = new Date().getTime()
      AI.treeDepth = play.depth
      // AI.treeDepth=4;

      AI.number = 0
      AI.setHistoryTable.lenght = 0

      var val = AI.getAlphaBeta(-99999, 99999, AI.treeDepth, com.arr2Clone(play.map), play.my)
      // var val = AI.iterativeSearch(com.arr2Clone(play.map),play.my)
      if (!val || val.value === -8888) {
        AI.treeDepth = 2
        val = AI.getAlphaBeta(-99999, 99999, AI.treeDepth, com.arr2Clone(play.map), play.my)
      }
      // var val = AI.iterativeSearch(com.arr2Clone(play.map),play.my);
      if (val && val.value !== -8888) {
        var man = play.mans[val.key]
        return [man.x, man.y, val.x, val.y]
      } else {
        return false
      }
    }
    AI.iterativeSearch = function (e, t) {
      var n = 100
      var r = 1
      var i = 8
      AI.treeDepth = 0
      var s = (new Date()).getTime()
      var o = {}
      for (var u = r; u <= i; u++) {
        var a = (new Date()).getTime()
        AI.treeDepth = u
        AI.aotuDepth = u
        o = AI.getAlphaBeta(-99999, 99999, AI.treeDepth, e, t)
        if (a - s > n) {
          return o
        }
      }
      return false
    }
    AI.getMapAllMan = function (e, t) {
      var n = []
      for (var r = 0; r < e.length; r++) {
        for (var i = 0; i < e[r].length; i++) {
          var s = e[r][i]
          if (s && play.mans[s].my === t) {
            play.mans[s].x = i
            play.mans[s].y = r
            n.push(play.mans[s])
          }
        }
      }
      return n
    }
    AI.getMoves = function (e, t) {
      var n = AI.getMapAllMan(e, t)
      var r = []
      var i = play.isFoul
      // console.log('AI.getMoves', n)
      for (var s = 0; s < n.length; s++) {
        var o = n[s]
        var u = o.bl(e)
        for (var a = 0; a < u.length; a++) {
          var f = o.x
          var l = o.y
          var c = u[a][0]
          var h = u[a][1]
          if (i[0] !== f || i[1] !== l || i[2] !== c || i[3] !== h) {
            r.push([f, l, c, h, o.key])
            // console.log(r)
          }
        }
      }
      return r
    }
    AI.getAlphaBeta = function (e, t, n, r, i) {
      if (n === 0) {
        return {
          value: AI.evaluate(r, i)
        }
      }
      var s = AI.getMoves(r, i)
      for (var o = 0; o < s.length; o++) {
        var u = s[o]
        var a = u[4]
        var f = u[0]
        var l = u[1]
        var c = u[2]
        var h = u[3]
        var p = r[h][c] || ''
        r[h][c] = a
        delete r[l][f]
        play.mans[a].x = c
        play.mans[a].y = h
        if (p === 'j0' || p === 'J0') {
          play.mans[a].x = f
          play.mans[a].y = l
          r[l][f] = a
          delete r[h][c]
          if (p) {
            r[h][c] = p
          }
          return {
            key: a,
            x: c,
            y: h,
            value: 8888
          }
        } else {
          var d = -AI.getAlphaBeta(-t, -e, n - 1, r, -i).value
          play.mans[a].x = f
          play.mans[a].y = l
          r[l][f] = a
          delete r[h][c]
          if (p) {
            r[h][c] = p
          }
          if (d >= t) {
            return {
              key: a,
              x: c,
              y: h,
              value: t
            }
          }
          if (d > e) {
            e = d
            if (AI.treeDepth === n) {
              var v = {
                key: a,
                x: c,
                y: h,
                value: e
              }
            }
          }
        }
      }
      if (AI.treeDepth === n) {
        if (!v) {
          return false
        } else {
          return v
        }
      }
      return {
        key: a,
        x: c,
        y: h,
        value: e
      }
    }
    AI.setHistoryTable = function (e, t, n, r) {
      AI.setHistoryTable.lenght++
      AI.historyTable[e] = {
        depth: t,
        value: n
      }
    }
    AI.evaluate = function (e, t) {
      var n = 0
      for (var r = 0; r < e.length; r++) {
        for (var i = 0; i < e[r].length; i++) {
          var s = e[r][i]
          if (s) {
            n += play.mans[s].value[r][i] * play.mans[s].my
          }
        }
      }
      AI.number++
      return n * t
    }
    AI.evaluate1 = function (e, t) {
      var n = 0
      for (var r in play.mans) {
        var i = play.mans[r]
        if (i.isShow) {
          n += i.value[i.y][i.x] * i.my
        }
      }
      AI.number++
      return n * t
    }
    var bill = {}
    bill.init = function () {
      if (com.store) {
        clearInterval(bill.timer)
        bill.setBillList(com.arr2Clone(com.initMap))
        play.isPlay = false
        com.show()
      } else {
        bill.timer = setInterval(() => {
          bill.init()
        }, 300)
      }
    }
    bill.setBillList = function (e) {
      var t = com.get('billList')
      for (var n = 0; n < com.store.length; n++) {
        var r = document.createElement('option')
        r.text = '棋谱' + (n + 1)
        r.value = n
        t.add(r, null)
      }
      t.addEventListener('change', function (t) {
        bill.setBox(com.store[this.value], e)
      })
      bill.setBox(com.store[0], e)
    }
    bill.setMove = function (e, t, n) {
      var bn = com.arr2Clone(n)
      for (let r = 0; r < bn.length; r++) {
        for (var i = 0; i < bn[r].length; i++) {
          var s = bn[r][i]
          if (s) {
            com.mans[s].x = i
            com.mans[s].y = r
            com.mans[s].isShow = true
          }
        }
      }
      for (var r = 0; r <= t; r++) {
        var bi = r * 4
        var o = e[bi + 1]
        var u = e[bi + 2]
        var a = e[bi + 0]
        var f = e[bi + 3]
        if (com.mans[n[f][u]]) {
          com.mans[n[f][u]].isShow = false
        }
        com.mans[n[o][a]].x = u
        com.mans[n[o][a]].y = f
        if (r === t) {
          com.showPane(a, o, u, f)
        }
        n[f][u] = n[o][a]
        delete n[o][a]
      }
      return n
    }
    bill.setBox = function (e, t) {
      var n = com.arr2Clone(t)
      var be = e.split('')
      var r = ''
      for (var i = 0; i < be.length; i += 4) {
        r += '<li id="move_' + i / 4 + '">'
        var s = e[i + 0]
        var o = e[i + 1]
        var u = e[i + 2]
        var a = e[i + 3]
        r += com.createMove(n, s, o, u, a)
        r += '</li>\n\r'
      }
      com.get('billBox').innerHTML = r
      var f = com.get('billBox').getElementsByTagName('li')
      for (let i = 0; i < f.length; i++) {
        f[i].addEventListener('click', function (n) {
          var r = this.getAttribute('id').split('_')[1]
          bill.setMove(e, r, t)
          com.show()
        })
      }
    }
  },
  // // 监听数据是否改变
  // watch: {
  //   // intrd是需要监听的数据
  //   goChess (newval, oldval) {
  //     console.log('newval', newval, 'oldval', oldval)
  //     this.content = newval // newval为监听到发生改变数据
  //     this.enrollItemBanks = newval
  //     // this.selectnum = newval[1]
  //     console.log(this.enrollItemBanks)
  //     this.total = newval.length
  //     setTimeout(() => {
  //       com.initMaplist = this.enrollItemBanks
  //       com.initMap = com.initMaplist[chessGoNum].ss
  //       console.log('com.initMaplist[chessGoNum]', com.initMaplist[chessGoNum].ss)
  //     }, 500)
  //   }
  // selectCet (newval, oldval) {
  //   this.selectnum = newval
  //   console.log('this.selectnum', this.selectnum, newval)
  // }
  // gradid (newval, oldval) {
  //   this.gradId = newval
  //   console.log('this.gradId', this.gradId, newval)
  // },
  // levelexam (newval, oldval) {
  //   this.levelexam = newval
  //   console.log('this.levelexam', this.levelexam, newval)
  // }
  // },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
    window.addEventListener('beforeunload', this.unload)
    // window.addEventListener('beforeunload', e => this.unload) // 注册一个匿名函数
    this.initCanvas()
    // window.showWin = this.showWin
    // // 当调整窗口大小时重绘canvas
    // window.onresize = () => {
    //   this.initCanvas()
    //   this.drewChess(this.Chess)
    // }
  },
  // 2 销毁这个监听事件
  destroyed () {
    // 销毁这个监听事件，需要找到这个函数，如果使用的是匿名函数的话，无法查找这个函数，这个事件也就没有办法被移除 ，在其他页面仍然会执行这个监听事件
    window.removeEventListener('beforeunload', this.unload)
  },
  methods: {
    unload (e) {
      e = e || window.event
      if (e) {
        // console.log(e)
        // 在这里阻止默认的刷新，弹出弹框
        e.returnValue = '重新加载将导致准考证号失效，是否重新加载'
        // return '重新加载将导致准考证号失效，是否重新加载'
      }
      return '重新加载将导致准考证号失效，是否重新加载'
    },
    // 初始化canvas
    initCanvas () {
      // console.log(com)
      com.init()
    },
    // 提交闯关结果
    updateEnrollFractionById (fraction, levelexam, gradId) {
      var that = this
      // console.log('参数：', fraction, levelexam, gradId)
      updateEnrollFractionById({
        id: that.gradId,
        fraction: fraction
      }).then(res => {
        // success
        console.log('提交闯关结果', res)
        that.$router.push({
          name: 'gradingResults',
          // name: 'mallList',
          query: {
            id: gradId,
            fractions: fraction,
            levelexam: levelexam
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .container{
    box-sizing: border-box;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .dotest{
      box-sizing: border-box;
      height: 40px;
      width: 100%;
      border-bottom: 1px solid #cecece;
      @include flex();
      margin-top: 30px;
      .left{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #EF0404;
      }
      .right{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        .time{
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #EF0404;
        }
      }
    }
    .dotest_content{
      box-sizing: border-box;
      margin-top: 40px;
      margin-bottom: 90px;
      @include flexed();
      .item_left{
        width: 225px;
        margin-right: 24px;
        .info{
          width: 225px;
          border: 1px solid #cecece;
          padding: 20px 30px;
          box-sizing: border-box;
          margin-bottom: 20px;
          .item_title{
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
          .item_info{
            width: 100%;
            text-align: left;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin: 10px 0;
            .question{
              color: #000;
              font-size: 30px;
            }
            .success{
              color: #EF0404;
              font-size: 30px;
            }
          }
        }
        .select {
          width: 225px;
          border: 1px solid #cecece;
          padding: 10px 30px 20px;
          box-sizing: border-box;
          @include flexed();
          .item_choose{
            cursor: not-allowed;
            width: 20px;
            height: 20px;
            border: 1px solid #cecece;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            text-align: center;
            line-height: 20px;
            margin-top: 10px;
            margin-right: 13px;
            &:nth-child(5n){
              margin-right: 0;
            }
          }
          .item_chooses{
            background-color: #008DE9;
            border: 1px solid #008DE9;
            color: #ffffff;
          }
          .agin_item_choose {
            background-color: #999;
            border: 1px solid #999;
            color: #000;
          }
        }
        .submit{
            width: 100px;
            height: 40px;
            background-color: #008DE9;
            color: #ffffff;
            text-align: center;
            line-height: 40px;
            font-size: 20px;
            margin: auto;
            margin-top: 50px;
            cursor: pointer;
          }
      }
      .item-rigts{
        width: 931px;
        border: 1px solid #cecece;
        padding-top: 20px;
        padding-bottom: 20px;
        // padding-left: 59px;
        box-sizing: border-box;
        margin: auto;
        position: relative;
        .loading{
          position: absolute;
          text-align: center;
          font-size: 28px;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          -webkit-animation: loading 2s  linear infinite;
          animation: loading 2s  linear infinite;
        }
        @-webkit-keyframes loading {
        50% {
          opacity: 0.2;
          }
        100% {
          opacity: 1;
          } }
        @keyframes loading {
         50% {
          opacity: 0.2;
         }
        100% {
          opacity: 1;
          }}
        .canvas-bg{
          width: 480px;
          background-color: #f8be7c;
          padding: 20px;
          margin: auto;
        }
        .center{
          width: 100%;
          margin: auto;
          .el-button--primary {
          color: #FFF;
          background-color: #409EFF;
          border-color: #409EFF;
          height: 35px;
          line-height: 12px;
          width: 100px;
          font-size: 20px;
        }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cetGoChess.vue